import Shelve from './Shelve';
import JoinPhysical from './JoinPhysical';
import PartnerShip from './PartnerShip';

export default {
    namespaced: true,
    JoinPhysical,
    Shelve,
    PartnerShip,
};
